import { createStyles, Theme } from '@zn-material-ui'
import messageImage from '@images/homepage/home_icon_message.png'
import picketImage from '@images/homepage/home_icon_picket.png'

export default (theme: Theme) =>
  createStyles({
    listItemStyle: {
      fontSize: '14px',
      color: '#999999',
      letterSpacing: '0',
      padding: '0 0 0 16px !important',
    },
    titleStyle: {
      fontSize: '14px !important',
      color: '#999999',
      textIndent: '8px',
      '& .arrowIcon': {
        color: '#B2B2B2',
      },
    },
    containerStyle: {
      zIndex: 999,
      position: 'absolute',
      top: '17px',
      left: '166px',
      borderBottom: 'unset',
      borderRadius: '2px',
      '& .displayLabel': {
        border: '1px solid #E5E5E5',
        width: '142px',
      },
    },
    root: {
      width: '100%',
      backgroundColor: theme.palette.secondary.main,
      position: 'fixed',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 0,
      '& header': {
        width: '1200px',
        boxShadow: 'none !important',
      },
    },
    appBar: {
      margin: '0 auto',
      width: '100%',
    },
    toolbar: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    grow: {
      flexGrow: 1,
    },
    logo: {
      width: '150px',
      height: '60px',
      display: 'inline-block',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      top: '2px',
      left: 0,
    },
    toolsItem: {
      cursor: 'pointer',
      marginRight: '50px',
      fontSize: 12,
      color: theme.palette.text.primary,
      display: 'flex',
      alignItems: 'center',
      height: 30,
      '& a': {
        width: '100%',
        height: '100%',
        display: 'inline-block',
      },
    },
    packetImg: {
      display: 'inline-block',
      width: 20,
      height: 20,
      background: `url(${picketImage}) no-repeat 0 0/20px 20px`,
      marginRight: '10px',
    },
    messageImg: {
      position: 'relative',
      display: 'inline-block',
      width: 20,
      height: 20,
      background: `url(${messageImage}) no-repeat 0 0/20px 20px`,
      marginRight: '10px',
    },

    count: {
      position: 'absolute',
      backgroundColor: '#F5212D',
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      display: 'inline-block',
      right: -5,
      top: -5,
    },
    userInfo: {
      position: 'relative',
      display: 'block',
      alignItems: 'center',
    },
    profile: {
      cursor: 'pointer',
      display: 'inline-block',
      width: '30px',
      height: '30px',
      borderRadius: '50%',
    },
    title: {
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
      height: '34px',
    },

    sectionDesktop: {
      width: 278,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
      position: 'relative',
      paddingRight: 104,
    },

    list: {
      marginLeft: -120,
      marginTop: 15,
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.30)',
      borderRadius: 2,
      border: 'none',
      padding: '10px 0',
      '@global': {
        '.dListItem': {
          fontSize: 14,
          color: '#333',
          borderBottom: 'none',
        },
      },
    },

    userName: {
      marginLeft: 32,
      width: 50,
      fontSize: 12,
      textAlign: 'center',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      position: 'absolute',
      top: 10,
    },
  })
